module.exports = __webpack_public_path__ + "static/media/filter_2.acea94a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/filter_2.jpg
// module id = 1862
// module chunks = 0